module.exports = __webpack_public_path__ + "img/dino-gamer.040c9112.jpeg";